import { useState } from "react";
import portalApi from "@/lib/portalApi";
import { toast } from "sonner";
import { Button } from "@/components/ui/button";
import { FileDown, Loader2 } from "lucide-react";

const date = (iso) => new Date(iso).toLocaleDateString("en-GB", { day: "numeric", month: "short", year: "numeric" });

const PdfBtn = ({ planId, phase, label }) => {
  const [busy, setBusy] = useState(false);
  const get = async () => {
    setBusy(true);
    try {
      const r = await portalApi.get(`/plans/${planId}/pdf`, { params: phase == null ? {} : { phase }, responseType: "blob" });
      const url = URL.createObjectURL(r.data);
      const a = document.createElement("a");
      a.href = url; a.download = `plan${phase == null ? "" : `_phase${phase + 1}`}.pdf`; a.click();
      URL.revokeObjectURL(url);
    } catch { toast.error("Could not download — please try again"); }
    finally { setBusy(false); }
  };
  return (
    <Button size="sm" variant="outline" onClick={get} disabled={busy} data-testid={`portal-pdf-${planId}-${phase ?? "full"}`}>
      {busy ? <Loader2 className="mr-1 h-3.5 w-3.5 animate-spin" /> : <FileDown className="mr-1 h-3.5 w-3.5" />} {label}
    </Button>
  );
};

export const PlanSummary = ({ plan }) => (
  <div className="rounded-2xl border border-slate-200 bg-white p-5" data-testid={`portal-plan-${plan.id}`}>
    <div className="flex flex-wrap items-baseline justify-between gap-2">
      <div className="font-heading text-lg font-bold capitalize text-slate-900">{plan.mode} plan</div>
      <span className="text-xs text-slate-400">Created {date(plan.created_at)}{plan.overview?.total_duration_weeks ? ` · ${plan.overview.total_duration_weeks} weeks` : ""}</span>
    </div>
    <ol className="mt-3 space-y-2">
      {plan.phases.map((ph, i) => (
        <li key={i} className="rounded-xl bg-slate-50 p-3">
          <div className="text-sm font-semibold text-slate-800">Phase {ph.number}: {ph.title}{ph.duration_weeks ? <span className="font-normal text-slate-400"> · {ph.duration_weeks} wks</span> : null}</div>
          {ph.summary && <p className="mt-1 text-xs text-slate-600">{ph.summary}</p>}
        </li>
      ))}
    </ol>
    <div className="mt-4 flex flex-wrap gap-2">
      <PdfBtn planId={plan.id} phase={null} label="Full plan PDF" />
      {plan.phases.map((ph, i) => <PdfBtn key={i} planId={plan.id} phase={i} label={`Phase ${ph.number}`} />)}
    </div>
  </div>
);
